import { Box, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import { colors } from "../../theme/theme";

const CustomTabs = ({ value, setValue, data, color, fullScreen }) => {
  const smallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: smallScreen ? "center" : "space-between",
        flexDirection: "row",
        width: fullScreen ? "100%" : "null",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: fullScreen ? "space-evenly" : "center",
          flexWrap: "wrap",
          width: fullScreen ? "100%" : "null",
        }}
      >
        {data?.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "8px 16px",
              backgroundColor: "transparent",
              border: `1px solid ${
                value === item?.value ? colors.primary : colors.textColor
              }`,
              cursor: "pointer",
              "@media (max-width: 600px)": {
                padding: "10px 12px",
              },
              flexGrow: fullScreen ? 1 : 0,
            }}
            onClick={() => setValue(item?.value)}
          >
            <Typography
              sx={{
                color:
                  value === item?.value ? colors.primary : colors.textColor,
                fontWeight: 400,
                fontSize: fullScreen ? "16px" : "14px",
                fontFamily:
                  value === item?.value ? "Inter-SemiBold" : "Inter-Medium",
                display: "flex",
                flexDirection: "row",
                "@media (max-width: 600px)": {
                  fontSize: 12,
                },
              }}
            >
              {item?.label}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default CustomTabs;
